import Typo from './Typo.view';
export default Typo;
